import { render, staticRenderFns } from "./NoticeHeader.vue?vue&type=template&id=258aa4cf&"
import script from "./NoticeHeader.vue?vue&type=script&lang=js&"
export * from "./NoticeHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports